import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
import { TagModule } from "@/store/modules/tag.module";
const TagsMachine = Machine({
    id: "TagsMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "name",
                type: "asc",
            },
            columnFilters: [],
        },
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            always: "gettingTeams",
        },
        gettingTeams: {
            tags: "gettingTeams",
            invoke: {
                id: "gettingTeams",
                src: async (context, event) => {
                    const data = await TagModule.GetTeams();
                    const teams = data?.teams;
                    if (!teams || teams.length === 0) {
                        return { noTeamAvailable: true };
                    }
                    else {
                        return { noTeamAvailable: false };
                    }
                },
                onDone: [
                    {
                        target: "appUserIsNotTeamLead",
                        cond: (context, event) => {
                            return event.data.noTeamAvailable;
                        },
                    },
                    { target: "gettingTags" },
                ],
                onError: { target: "serviceUnavailable" },
            },
        },
        gettingTags: {
            tags: "gettingTags",
            invoke: {
                id: "gettingTags",
                src: (context, event) => {
                    return TagModule.GetTagListings(context.searchData);
                },
                onDone: { target: "loadedTags" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedTags: {
            tags: "loadedTags",
            on: {
                GETTING_TAGS: { target: "gettingTags", actions: "assignSearchData" },
                ADD_TAG: { target: "addTag" },
                EDIT_TAG: { target: "editTag" },
                DELETE_TAG: { target: "deleteTag", actions: "ispageChanged" },
            },
        },
        addTag: {
            tags: "showAddTagModal",
            on: {
                ADDING_TAG: { target: "addingTag" },
                CLOSE_MODAL: { target: "loadedTags" },
            },
        },
        addingTag: {
            tags: "showAddTagModal",
            invoke: {
                id: "addingTag",
                src: (context, event) => {
                    return TagModule.CreateTag(event.tag);
                },
                onDone: { target: "gettingTags", actions: "showSuccessMessage" },
                onError: { target: "addTag" },
            },
        },
        editTag: {
            tags: "showEditTagModal",
            on: {
                EDITING_TAG: { target: "editingTag" },
                CLOSE_MODAL: { target: "loadedTags" },
            },
        },
        editingTag: {
            tags: "showEditTagModal",
            invoke: {
                id: "editingTag",
                src: (context, event) => {
                    return TagModule.UpdateTag(event.tag);
                },
                onDone: { target: "gettingTags", actions: "showSuccessMessage" },
                onError: { target: "editTag" },
            },
        },
        deleteTag: {
            tags: "showDeleteTagUI",
            on: {
                DELETING_TAG: { target: "deletingTag" },
                CLOSE_MODAL: { target: "loadedTags" },
            },
        },
        deletingTag: {
            tags: "showDeleteTagUI",
            invoke: {
                id: "deletingTag",
                src: (context, event) => {
                    return TagModule.DeleteTagById(event.tagId);
                },
                onDone: { target: "gettingTags", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedTags" },
            },
        },
        appUserIsNotTeamLead: {
            tags: "appUserIsNotTeamLead",
            type: "final",
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    const updatedSearchData = {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                    TagModule.AssignSearchParams(updatedSearchData);
                    return updatedSearchData;
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default TagsMachine;
